import fetcher from 'api/fetcher';
import { AxiosError } from 'axios';
import { ActEditingField } from 'utils/constants/admin';
import { NotificationName } from 'utils/constants/notification';

import { Act, updateAct } from 'store/models/acts';
import { addMagritteCustomNotification, addNotification, MagritteNotificationType } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

interface Error {
    response?: {
        status: number;
    };
}

export interface EditActData {
    [ActEditingField.DocumentNumber]: string | null;
    [ActEditingField.CorrectedAmount]: number | null;
    [ActEditingField.PeriodStart]: string | null;
    [ActEditingField.PeriodEnd]: string | null;
    [ActEditingField.Status]: string | null;
    [ActEditingField.SendStatus]: string | null;
    [ActEditingField.ActDate]: string | null;
}

type EditAct = (data: EditActData, actId: number, resetData: () => void) => AppThunkAction;

export const editAct: EditAct = (data, actId, resetData) => {
    return (dispatch) => {
        return fetcher
            .put<unknown, Act>(`/api/v1/acts/${actId}`, data)
            .then((data) => {
                resetData();
                dispatch(updateAct({ actId, newActData: data }));
            })
            .catch((err: AxiosError<Error>) => {
                const status = err.response?.status;
                const data = err.response?.data;

                switch (status) {
                    case 400:
                        dispatch(addNotification(NotificationName.EditingActDataError));
                        break;
                    case 403:
                        dispatch(addNotification(NotificationName.EditingActForbiddenError));
                        break;
                    case 404:
                        dispatch(addNotification(NotificationName.EditingActNotFoundError));
                        break;
                }
                if (status === 400 && data) {
                    const text = typeof data === 'string' ? data : JSON.stringify(data);
                    dispatch(
                        addMagritteCustomNotification({
                            type: MagritteNotificationType.Error,
                            text: text.slice(0, 1000),
                        })
                    );
                }
            });
    };
};
